import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

const userWithLatestAccount = (user, accountId) => {
  const getAccount = store.getters['accounts/getAccount'];
  const latestAccount =
    typeof getAccount === 'function' ? getAccount(Number(accountId)) : null;

  if (!latestAccount?.id) return user;

  return {
    ...user,
    accounts: user.accounts.map(account =>
      Number(account.id) === Number(accountId)
        ? {
            ...account,
            status: latestAccount.status,
            custom_attributes: latestAccount.custom_attributes,
          }
        : account
    ),
  };
};

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  const currentUser = userWithLatestAccount(user, to.params.accountId);
  const nextRoute = validateLoggedInRoutes(to, currentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
